import { useState } from "react";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

// import mui icons
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FolderDeleteIcon from "@mui/icons-material/FolderDelete";
import UpdateIcon from "@mui/icons-material/Update";

//import assets

//import components
import UploadDataSeeding from "../../dataSeeding/UploadDataSeeding";
import UpdateDataSeeding from "../../dataSeeding/UpdateDataSeeding";
import DeleteDataSeeding from "../../dataSeeding/DeleteDataSeeding";

function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ px: 2, pt: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function DataSeeding() {
    const [selectedTab, setSelectedTab] = useState(0);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <>
            <Tabs
                sx={{
                    "& .MuiTabs-indicator": {
                        display: "none", // Hide the indicator
                    },
                    // maxHeight: "35px",
                    minHeight: "8px",
                    display: "flex",
                    alignItems: "center",
                    "& .MuiTabs-flexContainer": {
                        height: "35px",
                    },
                    "& .MuiTab-root": {
                        minHeight: "30px",
                        padding: "0px 12px",
                        fontSize: "12px",
                        textTransform: "none",
                    },
                }}
                value={selectedTab}
                onChange={handleChange}
                centered
                aria-label="basic tabs example"
                className="tabs-container tabs-toggle"
            >
                <Tab
                    className="tab-labels"
                    iconPosition="start"
                    icon={<CloudUploadIcon />}
                    label="Upload Data"
                    {...a11yProps(0)}
                />
                <Tab
                    className="tab-labels"
                    iconPosition="start"
                    icon={<UpdateIcon />}
                    label="Update Data"
                    {...a11yProps(1)}
                />
                <Tab
                    className="tab-labels"
                    iconPosition="start"
                    icon={<FolderDeleteIcon />}
                    label="Delete Data"
                    {...a11yProps(2)}
                />
            </Tabs>

            <CustomTabPanel
                value={selectedTab}
                index={0}
            >
                <UploadDataSeeding />
            </CustomTabPanel>
            <CustomTabPanel
                value={selectedTab}
                index={1}
            >
                <UpdateDataSeeding />
            </CustomTabPanel>
            <CustomTabPanel
                value={selectedTab}
                index={2}
            >
                <DeleteDataSeeding />
            </CustomTabPanel>
        </>
    );
}

export default DataSeeding;
